"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _amalfi = _interopRequireDefault(require("./27_group_2024_03_26/amalfi"));

var _arcola = _interopRequireDefault(require("./27_group_2024_03_26/arcola"));

var _arona = _interopRequireDefault(require("./27_group_2024_03_26/arona"));

var _azzate = _interopRequireDefault(require("./27_group_2024_03_26/azzate"));

var _bagnoARipoli = _interopRequireDefault(require("./27_group_2024_03_26/bagno-a-ripoli"));

var _bergeggi = _interopRequireDefault(require("./27_group_2024_03_26/bergeggi"));

var _bracciano = _interopRequireDefault(require("./27_group_2024_03_26/bracciano"));

var _cadorago = _interopRequireDefault(require("./27_group_2024_03_26/cadorago"));

var _cairate = _interopRequireDefault(require("./27_group_2024_03_26/cairate"));

var _cassanoDAdda = _interopRequireDefault(require("./27_group_2024_03_26/cassano-d-adda"));

var _castelSanGiovanni = _interopRequireDefault(require("./27_group_2024_03_26/castel-san-giovanni"));

var _castiglionFiorentino = _interopRequireDefault(require("./27_group_2024_03_26/castiglion-fiorentino"));

var _cavagnolo = _interopRequireDefault(require("./27_group_2024_03_26/cavagnolo"));

var _collesalvetti = _interopRequireDefault(require("./27_group_2024_03_26/collesalvetti"));

var _dervio = _interopRequireDefault(require("./27_group_2024_03_26/dervio"));

var _dubino = _interopRequireDefault(require("./27_group_2024_03_26/dubino"));

var _feltre = _interopRequireDefault(require("./27_group_2024_03_26/feltre"));

var _gabicceMare = _interopRequireDefault(require("./27_group_2024_03_26/gabicce-mare"));

var _gaglianoDelCapo = _interopRequireDefault(require("./27_group_2024_03_26/gagliano-del-capo"));

var _lameziaTerme = _interopRequireDefault(require("./27_group_2024_03_26/lamezia-terme"));

var _lastraASigna = _interopRequireDefault(require("./27_group_2024_03_26/lastra-a-signa"));

var _lavagna = _interopRequireDefault(require("./27_group_2024_03_26/lavagna"));

var _leini = _interopRequireDefault(require("./27_group_2024_03_26/leini"));

var _loano = _interopRequireDefault(require("./27_group_2024_03_26/loano"));

var _mezzanino = _interopRequireDefault(require("./27_group_2024_03_26/mezzanino"));

var _montespertoli = _interopRequireDefault(require("./27_group_2024_03_26/montespertoli"));

var _nave = _interopRequireDefault(require("./27_group_2024_03_26/nave"));

var _orvieto = _interopRequireDefault(require("./27_group_2024_03_26/orvieto"));

var _piegaro = _interopRequireDefault(require("./27_group_2024_03_26/piegaro"));

var _ponteranica = _interopRequireDefault(require("./27_group_2024_03_26/ponteranica"));

var _rieti = _interopRequireDefault(require("./27_group_2024_03_26/rieti"));

var _romanoDEzzelino = _interopRequireDefault(require("./27_group_2024_03_26/romano-d-ezzelino"));

var _rottofreno = _interopRequireDefault(require("./27_group_2024_03_26/rottofreno"));

var _sanCascianoInValDiPesa = _interopRequireDefault(require("./27_group_2024_03_26/san-casciano-in-val-di-pesa"));

var _sanDonatoMilanese = _interopRequireDefault(require("./27_group_2024_03_26/san-donato-milanese"));

var _sannazzaroDeBurgondi = _interopRequireDefault(require("./27_group_2024_03_26/sannazzaro-de-burgondi"));

var _settimoMilanese = _interopRequireDefault(require("./27_group_2024_03_26/settimo-milanese"));

var _solesino = _interopRequireDefault(require("./27_group_2024_03_26/solesino"));

var _treviglio = _interopRequireDefault(require("./27_group_2024_03_26/treviglio"));

var _vicari = _interopRequireDefault(require("./27_group_2024_03_26/vicari"));

var _vittorioVeneto = _interopRequireDefault(require("./27_group_2024_03_26/vittorio-veneto"));

var _voghera = _interopRequireDefault(require("./27_group_2024_03_26/voghera"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _amalfi["default"], {}, _arcola["default"], {}, _arona["default"], {}, _azzate["default"], {}, _bagnoARipoli["default"], {}, _bergeggi["default"], {}, _bracciano["default"], {}, _cadorago["default"], {}, _cairate["default"], {}, _cassanoDAdda["default"], {}, _castelSanGiovanni["default"], {}, _castiglionFiorentino["default"], {}, _cavagnolo["default"], {}, _collesalvetti["default"], {}, _dervio["default"], {}, _dubino["default"], {}, _feltre["default"], {}, _gabicceMare["default"], {}, _gaglianoDelCapo["default"], {}, _lameziaTerme["default"], {}, _lastraASigna["default"], {}, _lavagna["default"], {}, _leini["default"], {}, _loano["default"], {}, _mezzanino["default"], {}, _montespertoli["default"], {}, _nave["default"], {}, _orvieto["default"], {}, _piegaro["default"], {}, _ponteranica["default"], {}, _rieti["default"], {}, _romanoDEzzelino["default"], {}, _rottofreno["default"], {}, _sanCascianoInValDiPesa["default"], {}, _sanDonatoMilanese["default"], {}, _sannazzaroDeBurgondi["default"], {}, _settimoMilanese["default"], {}, _solesino["default"], {}, _treviglio["default"], {}, _vicari["default"], {}, _vittorioVeneto["default"], {}, _voghera["default"]);

exports["default"] = _default;